import anime from 'animejs';

const animationEffect = ({
  origin,
  target,
  type,
  effect = 'easeInOutQuad',
  duration = 1000,
}) => {
  const { top: targetTop, left: targetLeft } = target.getBoundingClientRect();
  const { top: originTop, left: originLeft } = origin.getBoundingClientRect();
  if (type === 'fly') {
    const clone = origin.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.opacity = '0.75';
    clone.style.zIndex = '10000';
    clone.style.top = `${originTop}px`;
    clone.style.left = `${originLeft}px`;
    const centerOffsetX = (target.offsetWidth - origin.offsetWidth) / 2;
    const centerOffsetY = (target.offsetHeight - origin.offsetHeight) / 2;
    document.body.appendChild(clone);
    return anime({
      targets: clone,
      translateX: targetLeft - originLeft + centerOffsetX,
      translateY: targetTop - originTop + centerOffsetY,
      duration,
      easing: effect,
      complete() {
        clone.remove();
      },
    }).finished;
  }
  if (type === 'squash') {
    const { width: originWidth, height: originHeight } =
      origin.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } =
      target.getBoundingClientRect();
    return anime({
      targets: origin,
      transformOrigin: '0 0',
      translateX: targetLeft - originLeft - originWidth / 2 + targetWidth / 2,
      translateY: targetTop - originTop - originHeight / 2 + targetHeight / 2,
      scaleX: 0.05,
      scaleY: 0.05,
      duration,
      easing: effect,
    }).finished;
  }
  return null;
};

export default animationEffect;
